export enum DesignHuddleAttachmentAction {
  PlaceForeground = 'Foreground',
  PlaceBackground = 'Background',
}
